import React from 'react';
import { NOT_PRESENT } from '../../constants'
import styles from './ProfileNonAssetSection.module.css'

export default function ProfileNonAssetSection({ assets }) {

  assets = assets ? assets.filter(asset => asset?.type === NOT_PRESENT) : assets;

  const capitalize = (str) => `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
  return (
    assets.map((asset, i) => {
      return (
        <React.Fragment key={i}>
          <div className={styles.NonAssetRow}>{asset.type}</div>
          {
            Object.keys(asset.attributes).map((key, ii) => {
              if (asset.attributes[key]) {
                // create an array of key names
                const assetArray = key.replace(/not_present_/gi, '').split('_')
                let displayAssets = []
                assetArray.forEach((asset) => {
                  // if key is hvac or ahu, capitalize whole string
                  if (['hvac', 'ahu'].includes(asset)) {
                    displayAssets.push(asset.toUpperCase())
                  } else {
                    //else, capitalize first letter with function ^^
                    displayAssets.push(capitalize(asset))
                  }
                });
                // join them back together after processing
                const displayName = displayAssets.join(' ')
                
                return <div key={ii}>{displayName}</div>
              }
              return null
            })
          }
        </React.Fragment>
      )
    })
  );
}
